import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';
import { SpeedInsights } from '@vercel/speed-insights/react';

import { AdminProvider } from './contexts/AdminContext';
import AdminGear from './components/AdminGear';
import Layout from './components/Layout';
import Home from './pages/Home';
import Shop from './pages/Shop';
import FAQ from './pages/FAQ';
import Vote from './pages/Vote';
import Donate from './pages/Donate';
import Create from './pages/Create';
import Checkout from './pages/Checkout';
import Auction from './pages/Auction';

import '@solana/wallet-adapter-react-ui/styles.css';
import './App.css';

function App() {
  // Use environment variable for network, fallback to devnet
  const network = process.env.REACT_APP_SOLANA_NETWORK === 'mainnet-beta' 
    ? WalletAdapterNetwork.Mainnet 
    : WalletAdapterNetwork.Devnet;
  
  const endpoint = useMemo(() => {
    // Use custom RPC endpoint if provided, otherwise use default
    const rpcEndpoint = process.env.REACT_APP_RPC_ENDPOINT || clusterApiUrl(network);
    console.log('[App] Network:', network, '| RPC Endpoint:', rpcEndpoint);
    return rpcEndpoint;
  }, [network]);

  const wallets = useMemo(
    () => [
      new SolflareWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <AdminProvider>
            <Router>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/vote" element={<Vote />} />
                  <Route path="/donate" element={<Donate />} />
                  <Route path="/create" element={<Create />} />
                  <Route path="/auction" element={<Auction />} />
                </Routes>
              </Layout>
              <AdminGear />
            </Router>
            <SpeedInsights />
          </AdminProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;
